module.exports = __webpack_public_path__ + "img/mobilepainpoint4.edc9f98b.png";